// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var BillingTransactionState = function (x) {
    return x;
};
var tsBridgeBillingTransactio = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("BillingTransactionState")("__brandBillingTransactionState"));
    }
};
var writeBillingTransactionState = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showBillingTransactionState = Data_Show.showString;
var readBillingTransactionState = Simple_JSON.readString;
var ordBillingTransactionState = Data_Ord.ordString;
var newtypeBillingTransactionState = {
    Coercible0: function () {
        return undefined;
    }
};
var makeBillingTransactionState = BillingTransactionState;
var eqBillingTransactionState = Data_Eq.eqString;
export {
    BillingTransactionState,
    makeBillingTransactionState,
    unwrap,
    newtypeBillingTransactionState,
    eqBillingTransactionState,
    ordBillingTransactionState,
    showBillingTransactionState,
    readBillingTransactionState,
    writeBillingTransactionState,
    tsBridgeBillingTransactio
};
//# sourceMappingURL=index.js.map
